import Api from './rest'

export const MedalApi = new Api('https://medal.tv/api')
